import { apiRequest } from './api';

export const getLeagues = () =>
  apiRequest('GET', '/leagues');

export const getLeague = (id: string) =>
  apiRequest('GET', `/leagues/${id}`);

export const createLeague = (data: any) =>
  apiRequest('POST', '/leagues', data);

export const deleteLeague = (id: string) =>
  apiRequest('DELETE', `/leagues/${id}`);


// Console accessible debug methods available in development mode
if(process.env.NODE_ENV === 'development') {
  window.getLeagues = getLeagues;
  window.getLeague = getLeague;
  window.createLeague = createLeague;
  window.deleteLeague = deleteLeague;
}